function signedIn(){
    window.location.href = "/create-account";
}

export default signedIn;